export const formatPatientTaskQuery = (filters, limit, skip) => {
  return {
    ...filters,
    limit,
    skip,
  };
};
